module.exports = __webpack_public_path__ + "static/media/logo.6bc00e8f.png";